
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/electrical",
      function () {
        return require("private-next-pages/services/electrical/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/electrical"])
      });
    }
  